import { render, staticRenderFns } from "./AdDetails.vue?vue&type=template&id=a816c1bc&scoped=true"
import script from "./AdDetails.vue?vue&type=script&lang=js"
export * from "./AdDetails.vue?vue&type=script&lang=js"
import style0 from "./AdDetails.vue?vue&type=style&index=0&id=a816c1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a816c1bc",
  null
  
)

export default component.exports